import { IDeliveryDeadline } from 'contexts/manageOrder/types';
import config from 'controllers/config';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useApi } from 'services/api';

export const useManageOrder = () => {
  const [deliveryDeadline, setDeliveryDeadline] = useState<IDeliveryDeadline | null>(null);
  const { api } = useApi();

  const getPaymentDays = useCallback(async () => {
    const backendUrl = config.API_NODE;

    if (backendUrl) {
      const headers = { userfunctionkey: '67c6a1e7ce56d3d6fa748ab6d9af3fd7' };

      const { data } = await api.get<IDeliveryDeadline>(`${backendUrl}/penalty/daysUntilDeadline`, { headers });
      return data;
    }
  }, []);

  const daysUntilDeadlineLabel = useMemo(() => {
    if (!deliveryDeadline) return null;
    const days = deliveryDeadline.qtDiaPrazo;

    if (!days || days === 0) return null;

    return days > 1 ? `${days} dias que antecedem` : `${days} dia que antecede`;
  }, [deliveryDeadline]);

  useEffect(() => {
    getPaymentDays()
      .then((data) => {
        if (data) {
          setDeliveryDeadline(data);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, [getPaymentDays]);

  return { getPaymentDays, deliveryDeadline, daysUntilDeadlineLabel };
};
